import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

// i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";
import "./sidebar-custom.scss";

import avatar2 from "../../assets/images/users/man-1.png";

const Sidebar = (props) => {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const user = useSelector((state) => state.Login.user);
  const name = user ? user.name : "Master Admin";
  const role = user ? user.role : "Admin";

  const displayRole =
    role === "superAdmin"
      ? "Super Admin"
      : role
        ? role.charAt(0).toUpperCase() + role.slice(1)
        : "Master Admin";

  const closeMobileSidebar = () => {
    document.body.classList.remove("sidebar-enable");
    document.body.style.overflow = "";
  };

  // Close mobile sidebar on route navigation
  useEffect(() => {
    if (window.innerWidth < 992) {
      closeMobileSidebar();
    }
  }, [location.pathname]);

  // Clean up on desktop resize or unmount
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        document.body.classList.remove("sidebar-enable");
        document.body.style.overflow = "";
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      document.body.style.overflow = "";
    };
  }, []);

  // Track page scroll on desktop to eliminate top blank space when scrolled
  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth >= 992) {
        setIsScrolled(window.scrollY > 60);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <React.Fragment>
      {/* Mobile Drawer Glassmorphism Backdrop Overlay */}
      <div
        className="sidebar-backdrop d-lg-none"
        onClick={closeMobileSidebar}
        aria-hidden="true"
      />

      <div className={`vertical-menu ${isScrolled ? "is-scrolled" : ""}`}>
        <div className="d-flex flex-column h-100 overflow-hidden">
          {/* User Profile Header Card */}
          <div className="sidebar-user-card">
            {/* Mobile Close Button */}
            <button
              type="button"
              className="sidebar-mobile-close-btn d-lg-none"
              onClick={closeMobileSidebar}
              aria-label="Close Sidebar"
              title="Close Menu"
            >
              <i className="mdi mdi-close"></i>
            </button>

            <div className="sidebar-user-avatar-wrapper">
              <img
                src={avatar2}
                alt="User Avatar"
                className="sidebar-user-avatar"
              />
              <span className="user-online-status" title="Online"></span>
            </div>

            <div>
              <Link to="#" className="sidebar-user-name">
                {name}
              </Link>
              <span className="sidebar-user-role-badge">{displayRole}</span>
            </div>
          </div>

          {/* Independent Scrollable Navigation Menu */}
          <SidebarContent onNavigate={closeMobileSidebar} />
        </div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = (state) => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStatetoProps, {})(withTranslation()(Sidebar));
